import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class SeedRequestService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (requestId: number): Observable<SeedRequest[]> => {
    return this.apiHttp.get<SeedRequest[]>(`requests/${requestId}/seedrequests`);
  };
}

export interface SeedRequest {
  requestId: number;
  batchId: number;
  batchCreationDate: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/seed-request.service.ts